import { SimpleLayout, useLayout } from '@approvalmax/ui/src/components';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { routingService } from 'services/routing';
import { storageService } from 'services/storage';

import { Content } from './resources/components';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ containerMinSize: 'xxsmall' });

    const authenticated = storageService.authenticated();

    useEffect(() => {
        if (authenticated) {
            routingService.replaceToDefaultPath();
        }
    }, [authenticated]);

    if (authenticated) return null;

    return (
        <SimpleLayout size='xsmall' verticalAlign='start'>
            <Helmet>
                <title>{messages.title}</title>

                <meta name='description' content={messages.description} />
            </Helmet>

            <SimpleLayout.Content>
                <Content />
            </SimpleLayout.Content>
        </SimpleLayout>
    );
};

export default Page;
